import { PointsIcon } from "@Icons/MainIcons";
import { Grid, Skeleton } from "antd";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { MOBILE_BREAKPOINT_KEY } from "src/constants";
import { useDirection } from "src/i18n/direction";
import { getIsUserFetching, getUserDetails } from "src/store/slices/client";
import { compactNumber, formatNumber } from "src/utility";

export default function UserPoints() {
  const {totalPointsBalance } = useSelector(getUserDetails);
  const isUserFetching = useSelector(getIsUserFetching);
  const { t } = useTranslation();
  const direction = useDirection();
  const isLargeScreen = Grid.useBreakpoint()[MOBILE_BREAKPOINT_KEY];
  return (
    <div className="flex flex-1 select-none justify-end font-medium text-sm" dir={direction}>
      {isUserFetching ? (
        <Skeleton.Button active shape="round" style={{ height: 38, width: 90 }} />
      ) : (
        <div className="jusitfy-center outline-border-hover text-font-active flex items-center gap-1 rounded-full px-4 py-2 outline">
          <div className="text-icon-secondary">
            <PointsIcon />
          </div>
          <div>{isLargeScreen ? formatNumber(totalPointsBalance) : compactNumber(totalPointsBalance)}</div>
          <div className="font-medium">{t("Menu.pts")}</div>
        </div>
      )}
    </div>
  );
}
